import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logout from '../Components/Image/logout.png'
import Sidebar from '../Components/Sidebar';
import { Button, Table, DropdownButton, Dropdown, Card, Accordion } from 'react-bootstrap';
import { connect } from 'react-redux'
import MultiSelect from "react-multi-select-component";
import { getQATemplates } from '../store/actions/qaTemplateActions'
import { getPODetails, getPOSearch, postSaveStagesForLineItemPO, postEditStagesForLineItemPO } from '../store/actions/poDetailsActions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AuthHandlerInstance from '../Classes/AuthHandler'
import formatDate from '../Classes/FormatDate'
import Loading from '../Components/Loader'
import Pagination from 'react-bootstrap/Pagination'
import toast from 'react-hot-toast';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'


class DashboardLineItems extends React.Component {
    constructor(props) {
        super(props);
        const poID = this.props.location.state.data
        //const poID= '1'
        this.state = {
            QAPlanningtabledata: [],
            template: "",
            tabledata: [],
            modal: false,
            assignTemplateModal: false,
            poid: poID,
            customStageDropdown: false,
            selectedFromDropdown: "",
            template: [],
            opacity: "",
            editopacity:'',
            savedLineItems: {},
            QATemplateStages: [],
            selectedLineItem: '',
            selectedLineItems: [],
            templateId: '',
            isCustom: false,
            customStages : false,
            posData: [],
            disabledValue: true,
            editTemplateModal: false,
            currentPage: 1,
            posPerpage: 3,
            tableLineItemData: [],
            lineItemIdForEditTemplate: null
        };

        this.modal = this.modal.bind(this);
        this.assignTemplateModal = this.assignTemplateModal.bind(this);
        this.handleDataLoading = this.handleDataLoading.bind(this);
        this.editTemplate = this.editTemplate.bind(this);
        this.editTemplatemodal = this.editTemplatemodal.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleAssignTemplate = this.handleAssignTemplate.bind(this);
    }

    template() {


        this.props.qaTemplate.qaTemplate.map((item) => {

            this.state.template.push(item.name)
            this.setState({ template: this.state.template })
        }
        )
    }

    // ? function for assigning report start
    assignReport = async() => {

        var stages = []
        if (this.state.tabledata) {
            this.state.tabledata.map((el, index) => {
                var temp_obj = {
                    "seqNo": index,
                    "stageId": el.stage_id
                }
                stages.push(temp_obj)
            })
        }
        var template_mod = {
            "name": this.state.template,
            "lineItemId": this.state.selectedLineItem,
            "templateId": this.state.isCustom ? 0 : this.state.templateId,
            "stages": stages,
            "customStages": this.state.customStages
        }

        // ? when we will post an array : 2.0
        // let savedLineItems = [...this.state.savedLineItems]
        // savedLineItems.push(template_mod)
        // this.setState({ savedLineItems })

        console.log(template_mod, "template_mod", this.state.lineItemIdForEditTemplate, "prev lineitem")
        
        /*
            name
            lineItemId
            stages
            templateId
            seqNo
            stageId
            previousTemplateId
         */

        if (this.state.lineItemIdForEditTemplate) {
            var selectedLineItemForEdit = this.state.lineItemIdForEditTemplate
        } else {
            var selectedLineItemForEdit = null
        }

        console.log("prev lineitem data", selectedLineItemForEdit)
        
        

        // ? saving/editing line item
        if(selectedLineItemForEdit){
            toast.loading('Assigning template...', {
                duration: 1000
            });
            await this.props.postEditStagesForLineItemPO(this.state.poid, selectedLineItemForEdit, template_mod)
            toast.success(`Template assigned for Purchase OrderId: ${this.state.poid} Line ItemNo: ${selectedLineItemForEdit.lineItemId}`);
            
            // window.location.reload()
        } else {
            toast.loading('Assigning template...', {
                duration: 1000
            });
            await this.props.postSaveStagesForLineItemPO(this.state.poid, this.state.selectedLineItem, template_mod)
            toast.success(`Template assigned for Purchase OrderId: ${this.state.poid} Line ItemNo: ${this.state.selectedLineItem}`);
            // window.location.reload()
        }

        this.modal()
        await this.props.getQATemplates()
        await this.props.getPODetails(this.state.poid)
        await this.setState({ lineItemIdForEditTemplate: null })
        this.handleDataLoading()


    }
    // function for assigning report end

    // function for assigning multiple report start
    assignMultpleReport = async() => {


        var stages = []
        if (this.state.tabledata) {
            this.state.tabledata.map((el, index) => {
                var temp_obj = {
                    "seqNo": index,
                    "stageId": el.stage_id
                }
                stages.push(temp_obj)
            })
        }
        for (let index = 0; index < this.state.selectedLineItems.length; index++) {
            var template_mod = {
                "name": this.state.template,
                "lineItemId": this.state.selectedLineItems[index],
                "templateId": this.state.isCustom ? 0 : this.state.templateId,
                "stages": stages
            }
            await this.props.postSaveStagesForLineItemPO(this.state.poid, this.state.selectedLineItems[index], template_mod)
        }

        this.assignTemplateModal()
        await this.props.getQATemplates()
        await this.props.getPODetails(this.state.poid)
        await this.setState({ lineItemIdForEditTemplate: null, template: '', templateId: '', tabledata : [], selectedLineItems: [] })
        this.handleDataLoading()


    }
    // function for assigning multiple report end

    modal() {
        this.setState({ modal: !this.state.modal });

        if (this.state.modal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )

        }
    }

    // Toggle Assign Modal
    assignTemplateModal() {
        this.setState({ assignTemplateModal: !this.state.assignTemplateModal });

        if (this.state.assignTemplateModal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "0.2" }
            )

        }
    }

    // Select Multiple Item
    handleCheckboxChange = (e) => {
        var items = this.state.selectedLineItems
        if (e.target.checked) {
            let found = items.find((item) => item === e.target.value)
            if (!found) {
                items.push(e.target.value)
            }
            this.setState({ selectedLineItems: items })
        } else {
            console.log('here')
            var newItems = items.filter((item) => item !== e.target.value)
            console.log(newItems)
            this.setState({ selectedLineItems: newItems })
            console.log(this.state.selectedLineItems)
        }
    }

    // function for editing template
    editTemplatemodal = (lineItem) => {
        if (lineItem) {
            this.setState({ editTemplateModal: !this.state.editTemplateModal });
        } else {
            this.setState({ editTemplateModal: !this.state.editTemplateModal });
        }

        if (this.state.editTemplateModal == true) {
            this.setState(
                { opacity: "" }
            )

        }
        else {
            this.setState(
                { opacity: "" }
            )

        }
    }

    handleAssignTemplate = (e) => {
        var tabledata = []
        var templateid = 0
        try {
            tabledata = this.props.qaTemplate.qaTemplate.filter(res => res.name === e.target.value)[0].stages;
            templateid = this.props.qaTemplate.qaTemplate.filter(res => res.name === e.target.value)[0].qa_template_id
        } catch {
            tabledata = []
        }

        this.setState({ template: e.target.value, templateId: templateid, tabledata: tabledata, selectedFromDropdown: '' })
    }

    handletemplate = (e, lineitemid) => {
        this.modal()
        if(this.state.editTemplateModal){
            this.editTemplatemodal()
        }
        var tabledata = []
        var lineItemId = lineitemid
        var templateid = 0
        try {
            tabledata = this.props.qaTemplate.qaTemplate.filter(res => res.name === e.target.value)[0].stages;
            templateid = this.props.qaTemplate.qaTemplate.filter(res => res.name === e.target.value)[0].qa_template_id
        } catch {
            tabledata = []
        }

        this.setState({ template: e.target.value, templateId: templateid, tabledata: tabledata, selectedLineItem: lineItemId, selectedFromDropdown: '',customStages : false })
    }

    template() {
        this.props.getPODetails(this.state.poid)

        this.props.qaTemplate.qaTemplate.map((item) => {

            this.state.template.push(item.name)
            this.setState({ template: this.state.template })
            //  console.log("def",this.state.template)
        }



        )
    }
    handleDataLoading = async () => {

        await this.props.getPOSearch()
        this.setState({ posData: this.props.poDetails.poSearch.pos, tableLineItemData: this.props.poDetails.poDetails.lineItems })
        let user = AuthHandlerInstance.getUserPayLoad().fullName
        console.log("userID", user)
        this.state.posData.map((item) => {
            if (this.state.poid === item.PurchaseOrderId) {
                if (item.ClaimStatus == true) {
                    if (item.Claimby == user) {
                        this.setState({ disabledValue: false })
                    }
                }
            }
        })
        console.log("POS", this.props.poDetails)
        console.log("POSData", this.state.posData)




    }

    editTemplate = (item, index) => {
        console.log(item, index, "edittemplate")
        var temp_obj = {
            lineItemId : item.poLineItemId,
            previousTemplateId: item.poLineItemTemplateId
        }
        this.setState({ lineItemIdForEditTemplate: temp_obj })
        this.editTemplatemodal()
    }

    componentDidMount() {
        this.handleDataLoading()
        this.props.getQATemplates()
        this.props.getPODetails(this.state.poid)
        this.template()
        var QATemplateStages = []
        //console.log('#########',this.props.qaTemplate.qaTemplate)
        this.props.qaTemplate.qaTemplate.map((value, index) => (
            value.stages.map((value1, index1) => {
                //console.log('@@@@',value1) //stage_id state_name
                if (value1.state_name) {
                    QATemplateStages.push({ StageId: value1.stage_id, StageName: value1.state_name })

                }
            })
        ))
        QATemplateStages = QATemplateStages.filter((v, i, a) => a.findIndex(t => (t.StageId === v.StageId && t.StageName === v.StageName)) === i)
        this.setState({ QATemplateStages })
    }


    // rowClick(item){
    //     this.props.history.push({
    //       pathname: "/InspectiondashboardDocument",
    //       state: { },
    //     });
    //   }

    handleChange = (e) => {
        var tabledata = []
        var tabledata1 = this.state.tabledata
        this.setState({
            selectedFromDropdown: e
        })
        for (var i = 0; i < tabledata1.length; i++) {
            tabledata.push({ stage_id: tabledata1[i].stage_id, state_name: tabledata1[i].state_name })
        }
        for (var i = 0; i < e.length; i++) {

            tabledata.push({ stage_id: e[i].value, state_name: e[i].label })
        }

        tabledata = tabledata.filter((v, i, a) => a.findIndex(t => (t.stage_id === v.stage_id && t.state_name === v.state_name)) === i)
        let tmpName = this.state.template.includes('Custom') ? this.state.template : this.state.template + ' (Custom)';
        tmpName = e.length > 0 ? tmpName : tmpName.replace('(Custom)', "");
        tmpName = tmpName.trim();
        this.setState({ tabledata: tabledata, template: tmpName, isCustom: e.length > 0 ? true : false }, () => console.log('this.state.template', this.state.template))

    }

    deleteTemplateRow(state_name) {
        var tabledata1 = this.state.tabledata

        var tabledata = tabledata1.filter((item) => item.state_name !== state_name);

        this.setState({ tabledata , customStages: true})
    }

    handleClick(event) {
        this.setState({
            currentPage: Number(event.target.id)
        });
    }

    render() {
        var roles = AuthHandlerInstance.getRoles()
        var userInfo = AuthHandlerInstance.getUserID()
        var QATemplateStages = []

        

        this.props.qaTemplate.qaTemplate && this.props.qaTemplate.qaTemplate.map((value, index) => (
            value.stages.map((value1, index1) => {
                //console.log('@@@@',value1) //stage_id state_name
                if (value1.state_name) {
                    QATemplateStages.push({ StageId: value1.stage_id, StageName: value1.state_name })

                }
            })
        ))
        QATemplateStages = QATemplateStages.filter((v, i, a) => a.findIndex(t => (t.StageId === v.StageId && t.StageName === v.StageName)) === i)

        const po = this.props.poDetails.poDetails.poId
        const poID = this.props.poDetails.poDetails.poSapCode
        const vendorName = this.props.poDetails.poDetails.vendorName
        const location = this.props.poDetails.poDetails.location
        const dropdowndata = []
        {/* {console.log("PODETAILS",this.props.poDetails.postClaimStatus.status)} */ }
        // console.log("pos",this.props.poDetails.poSearch.pos)
        this.props.qaTemplate.qaTemplate.map((item) =>
            item.stages.map((element) => {
                if (element.state_name) {
                    dropdowndata.push({ label: element.state_name, value: element.stage_id })
                }
            })
        )
        var tabledata = this.state.tabledata

        // if (!this.props.poDetails && !this.props.poDetails.poDetails && !this.props.poDetails.poDetails.lineItems) {
        //     return (
        //         <div className="Container-fluid p-4 mt-5">
        //             <div className="row justify-content-center">
        //                 <div className="col-2" >Loading...</div>
        //             </div>
        //         </div>
        //     )

        // } else {

            // part of slicing
            
            //if (this.state.tableLineItemData) {
            var tableLineItemData = this.props.poDetails.poDetails.lineItems
            if(!tableLineItemData){

                return (
                    <Loading />
                        )

            }else{
                const { currentPage, posPerpage } = this.state;

                // Logic for displaying todos
                const indexOfLastTodo = currentPage * posPerpage;
                const indexOfFirstTodo = indexOfLastTodo - posPerpage;
                const currentTodos = tableLineItemData.slice(indexOfFirstTodo, indexOfLastTodo);
                const unAssignedTodos = tableLineItemData.filter((item) => item.poLineItemTemplateName === null);
                console.log(indexOfLastTodo, indexOfFirstTodo, "indexes")
                // Logic for displaying page numbers
                const pageNumbers = [];
                for (let i = 1; i <= Math.ceil(tableLineItemData.length / posPerpage); i++) {
                    pageNumbers.push(i);
                }

                // page number ui
                const renderPageNumbers = pageNumbers.map((number, index) => {
                    let totalPages = pageNumbers.length
                    if (index === 0) {
                        return (
                            <>
                                <Pagination.First
                                key={"firstpage"}
                                id={number}
                                onClick={
                                    currentPage === number
                                    ? () => {}
                                    : (e) => {
                                        this.handleClick(e);
                                        }
                                }
                                />
                                <Pagination.Prev
                                    key={"prevpage"}
                                    id={currentPage - 1}
                                    onClick={
                                        currentPage === number
                                        ? () => {}
                                        : (e) => {
                                            this.handleClick(e);
                                            }
                                    }
                                    />
                                    <Pagination.Item 
                                    key={number} 
                                    active={currentPage === number ? true : false}
                                    id={number}
                                    onClick={
                                        currentPage === number
                                        ? () => {}
                                        : (e) => {
                                            this.handleClick(e);
                                            }
                                    }
                                    >
                                    {number}
                                    </Pagination.Item>
                            </>
                        );
                    }
                    if (currentPage <= 5) {
                        if (number <=8) {
                            return (
                            <>
                                <Pagination.Item 
                                key={number} 
                                active={currentPage === number ? true : false}
                                id={number}
                                onClick={
                                    currentPage === number
                                    ? () => {}
                                    : (e) => {
                                        this.handleClick(e);
                                        }
                                }
                                >
                                {number}
                                </Pagination.Item>
                            </>
                            );
                        }
                        if (number === 9) {
                            return(
                                <Pagination.Ellipsis key={number} />
                            )
                        }
                    }
                    else if (totalPages - currentPage <= 4) {
                        if ((totalPages - 8) === number) {
                            return(
                                <Pagination.Ellipsis key={number} />
                            )
                        }
                        if ((totalPages - 7) === number || (totalPages - 6) === number || (totalPages - 5) === number || (totalPages - 4) === number || (totalPages - 3) === number || (totalPages - 2) === number || (totalPages - 1) === number) {
                            return(
                                <Pagination.Item 
                                key={number} 
                                active={currentPage === number ? true : false}
                                id={number}
                                onClick={
                                    currentPage === number
                                    ? () => {}
                                    : (e) => {
                                        this.handleClick(e);
                                        }
                                }
                                >
                                {number}
                                </Pagination.Item>
                            )
                        }
        
                    } else {
                        if ((currentPage - 4) === number) {
                            return(
                                <Pagination.Ellipsis key={number} />
                            )
                        }
                        if ((currentPage - 3) === number || (currentPage - 2) === number || (currentPage - 1) === number || currentPage === number || (currentPage + 1) === number || (currentPage + 2) === number || (currentPage + 3) === number) {
                            return(
                                <Pagination.Item 
                                key={number} 
                                active={currentPage === number ? true : false}
                                id={number}
                                onClick={
                                    currentPage === number
                                    ? () => {}
                                    : (e) => {
                                        this.handleClick(e);
                                        }
                                }
                                >
                                {number}
                                </Pagination.Item>
                            )
                        }
                        if ((currentPage + 4) === number) {
                            return(
                                <Pagination.Ellipsis key={number} />
                            )
                        }
                    }
                    if (index === totalPages - 1) {
                        return (
                            <>
                                <Pagination.Item 
                                key={totalPages} 
                                active={currentPage === number ? true : false}
                                id={totalPages}
                                onClick={
                                    currentPage === number
                                    ? () => {}
                                    : (e) => {
                                        this.handleClick(e);
                                        }
                                }
                                >
                                {totalPages}
                                </Pagination.Item>
                                <Pagination.Next
                                key={"nextpage"}
                                id={currentPage + 1}
                                onClick={
                                    currentPage === number
                                    ? () => {}
                                    : (e) => {
                                        this.handleClick(e);
                                        }
                                }
                                />
                                <Pagination.Last
                                key={"lastpage"}
                                id={totalPages}
                                onClick={
                                    currentPage === number
                                    ? () => {}
                                    : (e) => {
                                        this.handleClick(e);
                                        }
                                }
                                />
                            </>
                        )
                    }
                  });


                // stating pagination


                return (

                    <div>
                        {/* -------Modal start---------- */}
                        <Modal isOpen={this.state.modal}>

                            <ModalHeader HeaderStyle="modal-header">

                                <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Stages</h4>
                                <button type="button" className="close" aria-label="Close" onClick={this.modal} style={{ color: 'black' }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>

                            <ModalBody Style="modal-body modalbodys">
                                <div className="row pt-2">
                                    <div className="col-4 ml-2">
                                        <b>PO Number:</b> {poID}
                                    </div>
                                    <div className="col-6">
                                        <b>Vendor:</b> {vendorName}
                                    </div>
                                </div>

                                <div className="pt-2">
                                    <Table className="table1 table-bordered table-striped text-center">
                                        <thead>
                                            <tr className="table1">
                                                <th>Stages</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tabledata.map((item) => (
                                                <tr>
                                                    <td className="text-left">{item.state_name}</td>
                                                    <td>
                                                        <svg type="button" width="2em" height="1em" viewBox="0 0 16 16" className="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style={{ paddingRight: '5px' }} onClick={() => this.deleteTemplateRow(item.state_name)}>
                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                        </svg>
                                                    </td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </Table>
                                </div>


                                <MultiSelect
                                    options={dropdowndata}
                                    value={this.state.selectedFromDropdown}
                                    onChange={this.handleChange}
                                    labelledBy={this.state.selectedFromDropdown ? this.state.selectedFromDropdown : "Add Stages"}
                                />
                            </ModalBody>

                            <ModalFooter FooterStyle="modal-footer">
                                <div>

                                    <div className='row'>
                                        <div className='col float-right'>
                                            <button
                                                type="button"
                                                className="btn2 btn-sms1 mt-2 ml-4 float-left"
                                                onClick={this.modal}
                                            >
                                                Cancel
                </button>
                                            <button
                                                type="button"
                                                className="btn2 btn-sms1 mt-2 ml-4 float-right"
                                                onClick={this.assignReport.bind(this)}
                                            >
                                                Assign
                </button>
                                        </div>
                                    </div>
                                </div>


                            </ModalFooter>
                        </Modal>
                        {/* ----Modal End-------- */}

                        {/* -------Assign Template Modal start---------- */}
                        <Modal isOpen={this.state.assignTemplateModal}>

                            <ModalHeader HeaderStyle="modal-header">

                                <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Assign Templates</h4>
                                <button type="button" className="close" aria-label="Close" onClick={this.assignTemplateModal} style={{ color: 'black' }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>

                            <ModalBody Style="modal-body modalbodys">
                                <div className="row pt-2">
                                    <div className="col-4 ml-2">
                                        <b>PO Number:</b> {poID}
                                    </div>
                                    <div className="col-6">
                                        <b>Vendor:</b> {vendorName}
                                    </div>
                                </div>

                                <div className="pt-2">
                                    <Table className="table1 table-bordered table-striped text-center">
                                        <thead>
                                            <tr className="table1">
                                                <th></th>
                                                <th>Item No.</th>
                                                <th>Description</th>
                                                <th>PO Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {unAssignedTodos.map((item) => (
                                                <tr>
                                                    <td><input type="checkbox" onChange={this.handleCheckboxChange} value={item.poLineItemId} name="poLineItem[]" /></td>
                                                    <td className="align-middle">{item.poLineItemSapCode}</td>
                                                    <td className="align-middle">{item.poLineItemDescription}</td>
                                                    <td className="align-middle amount-text">{numberWithCommas(item.poLineItemAmount)}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </Table>
                                </div>
                                {this.state.selectedLineItems.length > 0 ? (
                                    <>
                                        <select className="form-control" disabled={this.state.selectedLineItems.length === 0} onChange={(e) => { this.handleAssignTemplate(e) }}>
                                            <option value="" disabled selected>Select Template</option>
                                            {this.props.qaTemplate.qaTemplate.map((item) => (
                                                <option key={item.name} value={item.name}>{item.name}</option>
                                            ))}
                                        </select>
                                        {tabledata.length > 0 ? (
                                            <>
                                        <div className="pt-2">
                                            <Table className="table1 table-bordered table-striped text-center">
                                                <thead>
                                                    <tr className="table1">
                                                        <th>Stages</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {tabledata.map((item) => (
                                                        <tr>
                                                            <td className="text-left">{item.state_name}</td>
                                                            <td>
                                                                <svg type="button" width="2em" height="1em" viewBox="0 0 16 16" className="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style={{ paddingRight: '5px' }} onClick={() => this.deleteTemplateRow(item.state_name)}>
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                                </svg>
                                                            </td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </Table>
                                        </div>


                                        <MultiSelect
                                            options={dropdowndata}
                                            value={this.state.selectedFromDropdown}
                                            onChange={this.handleChange}
                                            labelledBy={this.state.selectedFromDropdown ? this.state.selectedFromDropdown : "Add Stages"}
                                        />
                                        </>
                                        ) : '' }
                                    </>
                                ) : '' }
                            </ModalBody>

                            <ModalFooter FooterStyle="modal-footer">
                                <div>

                                    <div className='row'>
                                        <div className='col float-right'>
                                            <button
                                                type="button"
                                                className="btn2 btn-sms1 mt-2 ml-4 float-left"
                                                onClick={this.assignTemplateModal}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                disabled={this.state.selectedLineItems.length === 0 && tabledata.length === 0}
                                                type="button"
                                                className="btn2 btn-sms1 mt-2 ml-4 float-right"
                                                onClick={this.assignMultpleReport.bind(this)}
                                            >
                                                Assign
                                            </button>
                                        </div>
                                    </div>
                                </div>


                            </ModalFooter>
                        </Modal>
                        {/* ----Assign Template Modal End-------- */}

                        {/* -------Edit Template Modal start---------- */}
                        <Modal isOpen={this.state.editTemplateModal}>

                            <ModalHeader HeaderStyle="modal-header">

                                <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Edit Template Selection</h4>
                                <button type="button" className="close" aria-label="Close" onClick={this.editTemplate} style={{ color: 'black' }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </ModalHeader>

                            <ModalBody Style="modal-body modalbodys">
                                <div className="row pt-2">
                                    <div className="col-4 ml-2">
                                        <b>PO Number:</b> {poID}
                                    </div>
                                    <div className="col-6">
                                        <b>Vendor:</b> {vendorName}
                                    </div>
                                </div>

                                <div className="pt-2">
                                    <select className="form-control" onChange={(e) => { this.handletemplate(e) }}>
                                        <option value="" disabled selected>Select Template</option>
                                        {this.props.qaTemplate.qaTemplate.map((item) => (
                                            <option key={item.name} value={item.name}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>

                            </ModalBody>

                            <ModalFooter FooterStyle="modal-footer">
                                <div>

                                    <div className='row'>
                                        <div className='col float-right'>
                                            <button
                                                type="button"
                                                className="btn2 btn-sms1 mt-2 ml-4 float-left"
                                                onClick={this.editTemplatemodal}
                                            >
                                                Cancel
                </button>
                                        </div>
                                    </div>
                                </div>


                            </ModalFooter>
                        </Modal>
                        {/* ----Modal End-------- */}


                        <div className="Container-fluid p-4">

                            <div className="row">
                                <div className="col-md-10 header pt-2"><b>Expediting</b></div>
                                <div className="col-md-2 pt-2">
                                    {/* {
                        roles[6] ?
                        <Link  to ={{ pathname: '#',state : {} }}> 
                            <button className="btn2 btn-sms1 mr-4 float-right" type="submit">Save</button>
                        </Link>
                        :null
                    } */}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-4 ">
                                    <b>PO:</b> {poID}
                                </div>
                                <div className="col-md-4">
                                    <b>Vendor:</b> {vendorName}
                                </div>
                                {this.state.disabledValue ? '' : 
                                <div className="col-md-4">
                                    <Button className="float-right" onClick={() => this.assignTemplateModal()}>Assign Template</Button>
                                </div>
                                }
                            </div>

                            <div className="row">
                                <div className="col-md-12 pt-4 centre-alligned">
                                    <Table className="table1 text-left align-middle">
                                        <thead>
                                            <tr>
                                                {/* <th>PO Number</th> */}
                                                <th>Item No.</th>
                                                <th>Description</th>
                                                <th>PO Amount</th>
                                                <th>Location</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(this.props.poDetails.loading === false) ?
                                                (this.props.poDetails.poDetails.lineItems ? currentTodos.map((item, index) => (

                                                    <tr>
                                                        {/* <td>{item.poLineItemAmount}</td> */}
                                                        <td className="align-middle">{item.poLineItemSapCode}</td>
                                                        <td className="align-middle">{item.poLineItemDescription}</td>
                                                        <td className="align-middle amount-text">{numberWithCommas(item.poLineItemAmount)}</td>
                                                        <td className="align-middle">{location}</td>
                                                        <td className="align-middle amount-text">{item.poLineItemStatus}</td>
                                                    </tr>
                                                )) : () => {
                                                    window.location.replace("/ExpiditingDashboard")
                                                })
                                                : null}

                                        </tbody>
                                    </Table>

                                    {/* Page Number UI */}
                                    <hr></hr>


                                    <Pagination size="sm">{renderPageNumbers}</Pagination>


                                    <hr></hr>

                                    <div className="row">
                                        <div className="col md-10 ">
                                            <Accordion className=" accordion-pointer-cursor">
                                                <Card>
                                                    <Accordion.Toggle as={Card.Header} eventKey="1" className="accordianbar"
                                                        style={{ background: '#2e3135' }} >
                                                        <h5 style={{ color: 'white' }}>View Template</h5>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey="1">
                                                        <Card.Body className="fixed-column-table">

                                                            <Table className="table1 text-left align-middle ">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Stage Name</th>
                                                                        {this.props.qaTemplate.qaTemplate.map((item) => (
                                                                            <th>{item.name}</th>
                                                                        ))}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        QATemplateStages.map((item, i) => {
                                                                            // console.log(this.state.qaTemplate.qaTemplate)
                                                                            return (
                                                                                <tr>
                                                                                    <td>{item.StageName}</td>

                                                                                    {this.props.qaTemplate && this.props.qaTemplate.qaTemplate.map((itemIn) => (
                                                                                        <td>
                                                                                            {
                                                                                                itemIn && itemIn.stages.map((e) => {
                                                                                                    if (e.stage_id == item.StageId) {
                                                                                                        return <FontAwesomeIcon icon={'check'} size="1x" />
                                                                                                    }
                                                                                                })
                                                                                            }
                                                                                        </td>
                                                                                    ))}
                                                                                </tr>);
                                                                        })
                                                                    }
                                                                </tbody>








                                                            </Table>



                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
             }
    }
}

const ModalHeader = props => {
    return <div className="modal-header" style={{ backgroundColor: 'white', textAlign: ' center', verticalAlign: 'middle' }}>{props.children}</div>;
};

const ModalBody = props => {
    return <div className="modal-body">{props.children}</div>;
};

const ModalFooter = props => {
    return <div className="modal-footer">{props.children}</div>;
};


class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: '',
            display: 'none'
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    openModal() {
        this.setState({
            modalShow: 'show',
            display: 'block'
        });
    }

    closeModal() {
        this.setState({
            modalShow: '',
            display: 'none'
        });
    }

    componentDidMount() {
        this.props.isOpen ? this.openModal() : this.closeModal();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.props.isOpen ? this.openModal() : this.closeModal();
        }
    }

    render() {
        return (
            <div
                className={'modal fade ' + this.state.modalShow}
                tabIndex="-1"
                role="dialog"
                aria-hidden="true"
                style={{ display: this.state.display, 'overflow-y': 'scroll', top: '15%', position: 'absolute' }}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content ">{this.props.children}</div>
                </div>
            </div>
        );
    }
}




const mapStateToProps = (state) => ({ qaTemplate: state.qaTemplate, poDetails: state.poDetails, saveLineItemStatus: state.saveLineItemStatus, saveLineItemStatus: state.saveLineItemStatus })
export default connect(mapStateToProps, { getQATemplates, getPODetails, getPOSearch, postSaveStagesForLineItemPO, postEditStagesForLineItemPO })(DashboardLineItems)